"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var TemplateIcon = function TemplateIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6 4c-1.108 0-2 .892-2 2s.892 2 2 2 2-.892 2-2-.892-2-2-2zM2 6c0-2.212 1.788-4 4-4a3.997 3.997 0 0 1 3.875 3.001l4.248.008A3.997 3.997 0 0 1 18 2c2.212 0 4 1.788 4 4a3.997 3.997 0 0 1-3 3.874v4.252c1.727.443 3 2.007 3 3.874 0 2.212-1.788 4-4 4a3.997 3.997 0 0 1-3.874-3H9.874A3.997 3.997 0 0 1 6 22c-2.212 0-4-1.788-4-4a3.997 3.997 0 0 1 3-3.874V9.874A3.997 3.997 0 0 1 2 6zm5 3.874v4.252A4 4 0 0 1 9.874 17h4.252A4 4 0 0 1 17 14.126V9.874a4 4 0 0 1-2.872-2.865L9.874 7A4 4 0 0 1 7 9.874zm9-3.854A1.996 1.996 0 0 0 18 8c1.108 0 2-.892 2-2s-.892-2-2-2a1.996 1.996 0 0 0-2 2.012v.008zM6 16c-1.108 0-2 .892-2 2s.892 2 2 2 2-.892 2-2-.892-2-2-2zm12 0c-1.108 0-2 .892-2 2s.892 2 2 2 2-.892 2-2-.892-2-2-2z"
  }));
};
TemplateIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var config = {
  angConfiguration: {
    typeURL: 'http://anypoint.com/vocabs/digital-repository#MuleTemplateAsset',
    assetType: 'MuleTemplate'
  },
  owner: {
    gusTeam: 'TBD'
  },
  name: 'Template',
  publication: {
    inferredBy: [{
      classifiers: ['mule-application-template']
    }, {
      typeProperty: 'template'
    }],
    files: [{
      id: 'mule4',
      classifier: 'mule-application-template',
      packaging: 'jar'
    }, {
      id: 'mule3',
      classifier: null,
      packaging: 'zip'
    }],
    minimumInputSets: [{
      files: ['mule4']
    }, {
      files: ['mule3']
    }],
    customProperties: [{
      name: 'isMozartTemplate',
      storeAsAttribute: true
    }],
    extensionPoints: [{
      name: 'legacyMetadataExtraction'
    }]
  },
  portal: {
    icon: TemplateIcon,
    color: '#5e66f9' // indigo3
  },
  keywords: ['template', 'application', 'app']
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map